import Kakao from "../images/simple-cert/kakao.webp";
import Naver from "../images/simple-cert/naver.webp";
import Pass from "../images/simple-cert/pass.webp";
import Toss from "../images/simple-cert/toss.webp";
import Dream from "../images/simple-cert/dream.webp";
import Wooribank from "../images/simple-cert/wooribank.webp";
import SamsungPass from "../images/simple-cert/samsung-pass.webp";

export const providers: { [key: string]: any } = {
    NAVER: { url: Naver, text: "네이버" },
    KAKAO: { url: Kakao, text: "카카오" },
    TOSS: { url: Toss, text: "토스" },
    PASS: { url: Pass, text: "PASS" },
    DREAM: { url: Dream, text: '드림인증' },
    WOORIBANK: { url: Wooribank, text: "우리인증서" },
    SAMSUNG: { url: SamsungPass, text: "삼성패스" },
};

export const service_title = {
    AUTH: "간편인증",
    SIGN: "전자서명",
    VCI: "본인확인",
    WITHDRAWAL: "출금동의"
}

export const service_personal_info = {
    AUTH: "CI",
    SIGN: "전자서명",
    VCI: "CI"
}